var map = {
	"./email.svg": 1994,
	"./facebook.svg": 8610,
	"./line.svg": 2912,
	"./linkedIn.svg": 4792,
	"./pinterest.svg": 580,
	"./reddit.svg": 7790,
	"./telegram.svg": 1567,
	"./twitter.svg": 8623,
	"./whatsApp.svg": 4400
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4890;